/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconClothesRack = createReactComponent("clothes-rack", "IconClothesRack", [
  ["path", { d: "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M12 7v14", key: "svg-1" }],
  ["path", { d: "M9 21h6", key: "svg-2" }],
  ["path", { d: "M7.757 9.243a6 6 0 0 0 8.486 0", key: "svg-3" }]
]);

export { IconClothesRack as default };
//# sourceMappingURL=IconClothesRack.js.map
